export default [
    {
        path: 'banner',
        component: () => import(
            /* webpackChunkName: 'banners' */
            '@/views/parametrizacao/banners/Index'
        ),
        redirect: 'banner/index',
        children: [
            {
                name: 'parametrizacao-banner-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'banners' */
                    '@/views/parametrizacao/banners/List.vue'
                ),
            },
            {
                name: 'parametrizacao-banner-create',
                path: 'create',
                component: () => import(
                    /* webpackChunkName: 'banners' */
                    '@/views/parametrizacao/banners/Form.vue'
                ),
            },
            {
                name: 'parametrizacao-banner-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(
                    /* webpackChunkName: 'banners' */
                    '@/views/parametrizacao/banners/Form.vue'
                ),
            },
        ],
    },
]
